import { S as SvelteComponent, i as init, s as safe_not_equal, a as create_slot, e as element, b as insert, u as update_slot, t as transition_in, d as transition_out, f as detach, o as onMount, g as binding_callbacks, l as listen, h as tick, j as onDestroy, k as append, m as create_component, n as mount_component, p as destroy_component, q as compute_rest_props, r as assign, v as exclude_internal_props, w as set_attributes, x as toggle_class, y as self, z as stop_propagation, A as get_spread_update, B as empty, C as group_outros, D as check_outros, E as get_spread_object } from './common/index-ef2e340f.js';

/* node_modules/svelte-accessible-dialog/src/components/DialogPortal.svelte generated by Svelte v3.37.0 */

function create_fragment(ctx) {
	let div;
	let current;
	const default_slot_template = /*#slots*/ ctx[2].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[1], null);

	return {
		c() {
			div = element("div");
			if (default_slot) default_slot.c();
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (default_slot) {
				default_slot.m(div, null);
			}

			/*div_binding*/ ctx[3](div);
			current = true;
		},
		p(ctx, [dirty]) {
			if (default_slot) {
				if (default_slot.p && dirty & /*$$scope*/ 2) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[1], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (default_slot) default_slot.d(detaching);
			/*div_binding*/ ctx[3](null);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	let ref;
	let portal;

	onMount(() => {
		// Create and append a DOM node to `document.body`
		// and render the component into it.
		portal = document.createElement("div");

		portal.setAttribute("data-svelte-dialog-portal", "true");
		document.body.appendChild(portal);
		portal.appendChild(ref);

		return () => {
			document.body.removeChild(portal);
		};
	});

	function div_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			ref = $$value;
			$$invalidate(0, ref);
		});
	}

	$$self.$$set = $$props => {
		if ("$$scope" in $$props) $$invalidate(1, $$scope = $$props.$$scope);
	};

	return [ref, $$scope, slots, div_binding];
}

class DialogPortal extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

/* node_modules/svelte-accessible-dialog/src/components/TrapScreenReader.svelte generated by Svelte v3.37.0 */

function create_fragment$1(ctx) {
	let current;
	const default_slot_template = /*#slots*/ ctx[2].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[1], null);

	return {
		c() {
			if (default_slot) default_slot.c();
		},
		m(target, anchor) {
			if (default_slot) {
				default_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, [dirty]) {
			if (default_slot) {
				if (default_slot.p && dirty & /*$$scope*/ 2) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[1], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (default_slot) default_slot.d(detaching);
		}
	};
}

function instance$1($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	let { enabled } = $$props;
	let originalAttributes = [];

	const hideFromScreenReader = node => {
		originalAttributes.push({
			ariaHidden: node.getAttribute("aria-hidden"),
			inert: node.getAttribute("inert")
		});

		node.setAttribute("aria-hidden", "true");
		node.setAttribute("inert", "true");
	};

	const exposeToScreenReader = (node, i) => {
		const { ariaHidden, inert } = originalAttributes[i];

		if (!ariaHidden) {
			node.removeAttribute("aria-hidden");
		} else {
			node.setAttribute("aria-hidden", ariaHidden);
		}

		if (!inert) {
			node.removeAttribute("inert");
		}
	};

	onMount(() => {
		if (!enabled) {
			// `DialogContent` has the `aria-modal` attribute. This indicates to screen readers
			// that only content contained within the dialog should be accessible to the user.
			// Modern screen readers respect this attribute. In cases where support is inadequate,
			// this legacy workaround can be enabled.
			return;
		}

		// Grab all children in the `body` except for the dialog portal
		const children = document.querySelectorAll("body > *:not([data-svelte-dialog-portal])");

		children.forEach(hideFromScreenReader);

		return () => {
			children.forEach(exposeToScreenReader);
		};
	});

	$$self.$$set = $$props => {
		if ("enabled" in $$props) $$invalidate(0, enabled = $$props.enabled);
		if ("$$scope" in $$props) $$invalidate(1, $$scope = $$props.$$scope);
	};

	return [enabled, $$scope, slots];
}

class TrapScreenReader extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance$1, create_fragment$1, safe_not_equal, { enabled: 0 });
	}
}

/* node_modules/svelte-accessible-dialog/src/components/TrapFocus.svelte generated by Svelte v3.37.0 */

function create_fragment$2(ctx) {
	let div;
	let current;
	let mounted;
	let dispose;
	const default_slot_template = /*#slots*/ ctx[5].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[4], null);

	return {
		c() {
			div = element("div");
			if (default_slot) default_slot.c();
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (default_slot) {
				default_slot.m(div, null);
			}

			/*div_binding*/ ctx[6](div);
			current = true;

			if (!mounted) {
				dispose = listen(window, "keydown", /*handleKeydown*/ ctx[1]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (default_slot) {
				if (default_slot.p && dirty & /*$$scope*/ 16) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[4], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (default_slot) default_slot.d(detaching);
			/*div_binding*/ ctx[6](null);
			mounted = false;
			dispose();
		}
	};
}

function instance$2($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	let { initialFocusElement } = $$props;
	let { returnFocusElement } = $$props;
	let ref;
	let tabbableChildren;
	let firstTabbableChild;
	let lastTabbableChild;
	let returnFocusElem;

	onMount(() => {
		returnFocusElem = returnFocusElement || document.activeElement;
		tabbableChildren = [...ref.querySelectorAll("*")].filter(node => node.tabIndex >= 0);
		firstTabbableChild = tabbableChildren[0];
		lastTabbableChild = tabbableChildren[tabbableChildren.length - 1];

		// Wait for children to mount before trying to focus `initialFocusElement`
		tick().then(() => {
			if (initialFocusElement) {
				initialFocusElement.focus();
			} else {
				const initialFocusElem = ref.querySelector("[autofocus]") || firstTabbableChild || ref.querySelector("[data-svelte-dialog-content]");
				initialFocusElem.focus();
			}
		});
	});

	onDestroy(() => {
		if (returnFocusElem) {
			returnFocusElem.focus();
		}
	});

	// We can't test keyboard semantics in `jsdom`, so it doesn't
	// make sense to include this function in the coverage report.
	// istanbul ignore next
	const handleKeydown = event => {
		if (event.key !== "Tab") {
			return;
		}

		if (tabbableChildren.length === 0) {
			event.preventDefault();
		}

		if (event.shiftKey) {
			// Handle shift + tab
			if (document.activeElement === firstTabbableChild) {
				event.preventDefault();
				lastTabbableChild.focus();
			}
		} else {
			if (document.activeElement === lastTabbableChild) {
				event.preventDefault();
				firstTabbableChild.focus();
			}
		}
	};

	function div_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			ref = $$value;
			$$invalidate(0, ref);
		});
	}

	$$self.$$set = $$props => {
		if ("initialFocusElement" in $$props) $$invalidate(2, initialFocusElement = $$props.initialFocusElement);
		if ("returnFocusElement" in $$props) $$invalidate(3, returnFocusElement = $$props.returnFocusElement);
		if ("$$scope" in $$props) $$invalidate(4, $$scope = $$props.$$scope);
	};

	return [
		ref,
		handleKeydown,
		initialFocusElement,
		returnFocusElement,
		$$scope,
		slots,
		div_binding
	];
}

class TrapFocus extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance$2, create_fragment$2, safe_not_equal, {
			initialFocusElement: 2,
			returnFocusElement: 3
		});
	}
}

/* node_modules/svelte-accessible-dialog/src/components/LockScroll.svelte generated by Svelte v3.37.0 */

function create_fragment$3(ctx) {
	let current;
	const default_slot_template = /*#slots*/ ctx[1].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[0], null);

	return {
		c() {
			if (default_slot) default_slot.c();
		},
		m(target, anchor) {
			if (default_slot) {
				default_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, [dirty]) {
			if (default_slot) {
				if (default_slot.p && dirty & /*$$scope*/ 1) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[0], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (default_slot) default_slot.d(detaching);
		}
	};
}

function instance$3($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;

	onMount(() => {
		const { body, documentElement: html } = document;
		const scrollBarWidth = window.innerWidth - html.clientWidth;
		const bodyPaddingRight = parseInt(window.getComputedStyle(body).getPropertyValue("padding-right")) || 0;

		// 1. Fixes a bug in iOS and desktop Safari whereby setting `overflow: hidden` on
		//    the html/body does not prevent scrolling.
		// 2. Fixes a bug in desktop Safari where `overflowY` does not prevent scroll if an
		//   `overflow-x` style is also applied to the body.
		html.style.position = "relative"; // [1]

		html.style.overflow = "hidden"; // [2]
		body.style.position = "relative"; // [1]
		body.style.overflow = "hidden"; // [2]
		body.style.paddingRight = `${bodyPaddingRight + scrollBarWidth}px`;

		return () => {
			html.style.position = "";
			html.style.overflow = "";
			body.style.position = "";
			body.style.overflow = "";
			body.style.paddingRight = "";
		};
	});

	$$self.$$set = $$props => {
		if ("$$scope" in $$props) $$invalidate(0, $$scope = $$props.$$scope);
	};

	return [$$scope, slots];
}

class LockScroll extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance$3, create_fragment$3, safe_not_equal, {});
	}
}

/* node_modules/svelte-accessible-dialog/src/components/DialogOverlayInner.svelte generated by Svelte v3.37.0 */

function add_css() {
	var style = element("style");
	style.id = "svelte-1ewfmqq-style";
	style.textContent = "div.svelte-1ewfmqq{background-color:rgba(0, 0, 0, 0.3);position:fixed;top:0;right:0;bottom:0;left:0;overflow:auto}";
	append(document.head, style);
}

// (33:4) <LockScroll>
function create_default_slot_2(ctx) {
	let div;
	let current;
	let mounted;
	let dispose;
	const default_slot_template = /*#slots*/ ctx[7].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[8], null);
	let div_levels = [/*$$restProps*/ ctx[5], { "data-svelte-dialog-overlay": "" }];
	let div_data = {};

	for (let i = 0; i < div_levels.length; i += 1) {
		div_data = assign(div_data, div_levels[i]);
	}

	return {
		c() {
			div = element("div");
			if (default_slot) default_slot.c();
			set_attributes(div, div_data);
			toggle_class(div, "svelte-1ewfmqq", true);
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (default_slot) {
				default_slot.m(div, null);
			}

			current = true;

			if (!mounted) {
				dispose = listen(div, "click", self(stop_propagation(/*handleClick*/ ctx[3])));
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && dirty & /*$$scope*/ 256) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[8], dirty, null, null);
				}
			}

			set_attributes(div, div_data = get_spread_update(div_levels, [
				dirty & /*$$restProps*/ 32 && /*$$restProps*/ ctx[5],
				{ "data-svelte-dialog-overlay": "" }
			]));

			toggle_class(div, "svelte-1ewfmqq", true);
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (default_slot) default_slot.d(detaching);
			mounted = false;
			dispose();
		}
	};
}

// (32:2) <TrapFocus {initialFocusElement} {returnFocusElement}>
function create_default_slot_1(ctx) {
	let lockscroll;
	let current;

	lockscroll = new LockScroll({
			props: {
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(lockscroll.$$.fragment);
		},
		m(target, anchor) {
			mount_component(lockscroll, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const lockscroll_changes = {};

			if (dirty & /*$$scope, $$restProps*/ 288) {
				lockscroll_changes.$$scope = { dirty, ctx };
			}

			lockscroll.$set(lockscroll_changes);
		},
		i(local) {
			if (current) return;
			transition_in(lockscroll.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(lockscroll.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(lockscroll, detaching);
		}
	};
}

// (31:0) <TrapScreenReader enabled={ariaModalLegacy}>
function create_default_slot(ctx) {
	let trapfocus;
	let current;

	trapfocus = new TrapFocus({
			props: {
				initialFocusElement: /*initialFocusElement*/ ctx[0],
				returnFocusElement: /*returnFocusElement*/ ctx[1],
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(trapfocus.$$.fragment);
		},
		m(target, anchor) {
			mount_component(trapfocus, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const trapfocus_changes = {};
			if (dirty & /*initialFocusElement*/ 1) trapfocus_changes.initialFocusElement = /*initialFocusElement*/ ctx[0];
			if (dirty & /*returnFocusElement*/ 2) trapfocus_changes.returnFocusElement = /*returnFocusElement*/ ctx[1];

			if (dirty & /*$$scope, $$restProps*/ 288) {
				trapfocus_changes.$$scope = { dirty, ctx };
			}

			trapfocus.$set(trapfocus_changes);
		},
		i(local) {
			if (current) return;
			transition_in(trapfocus.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(trapfocus.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(trapfocus, detaching);
		}
	};
}

function create_fragment$4(ctx) {
	let trapscreenreader;
	let current;
	let mounted;
	let dispose;

	trapscreenreader = new TrapScreenReader({
			props: {
				enabled: /*ariaModalLegacy*/ ctx[2],
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(trapscreenreader.$$.fragment);
		},
		m(target, anchor) {
			mount_component(trapscreenreader, target, anchor);
			current = true;

			if (!mounted) {
				dispose = listen(window, "keydown", /*handleKeydown*/ ctx[4]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			const trapscreenreader_changes = {};
			if (dirty & /*ariaModalLegacy*/ 4) trapscreenreader_changes.enabled = /*ariaModalLegacy*/ ctx[2];

			if (dirty & /*$$scope, initialFocusElement, returnFocusElement, $$restProps*/ 291) {
				trapscreenreader_changes.$$scope = { dirty, ctx };
			}

			trapscreenreader.$set(trapscreenreader_changes);
		},
		i(local) {
			if (current) return;
			transition_in(trapscreenreader.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(trapscreenreader.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(trapscreenreader, detaching);
			mounted = false;
			dispose();
		}
	};
}

function instance$4($$self, $$props, $$invalidate) {
	const omit_props_names = ["onDismiss","initialFocusElement","returnFocusElement","ariaModalLegacy"];
	let $$restProps = compute_rest_props($$props, omit_props_names);
	let { $$slots: slots = {}, $$scope } = $$props;
	let { onDismiss } = $$props;
	let { initialFocusElement } = $$props;
	let { returnFocusElement } = $$props;
	let { ariaModalLegacy } = $$props;

	const handleClick = () => {
		onDismiss();
	};

	const handleKeydown = event => {
		if (event.key === "Escape") {
			onDismiss();
		}
	};

	$$self.$$set = $$new_props => {
		$$props = assign(assign({}, $$props), exclude_internal_props($$new_props));
		$$invalidate(5, $$restProps = compute_rest_props($$props, omit_props_names));
		if ("onDismiss" in $$new_props) $$invalidate(6, onDismiss = $$new_props.onDismiss);
		if ("initialFocusElement" in $$new_props) $$invalidate(0, initialFocusElement = $$new_props.initialFocusElement);
		if ("returnFocusElement" in $$new_props) $$invalidate(1, returnFocusElement = $$new_props.returnFocusElement);
		if ("ariaModalLegacy" in $$new_props) $$invalidate(2, ariaModalLegacy = $$new_props.ariaModalLegacy);
		if ("$$scope" in $$new_props) $$invalidate(8, $$scope = $$new_props.$$scope);
	};

	return [
		initialFocusElement,
		returnFocusElement,
		ariaModalLegacy,
		handleClick,
		handleKeydown,
		$$restProps,
		onDismiss,
		slots,
		$$scope
	];
}

class DialogOverlayInner extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-1ewfmqq-style")) add_css();

		init(this, options, instance$4, create_fragment$4, safe_not_equal, {
			onDismiss: 6,
			initialFocusElement: 0,
			returnFocusElement: 1,
			ariaModalLegacy: 2
		});
	}
}

/* node_modules/svelte-accessible-dialog/src/components/DialogOverlay.svelte generated by Svelte v3.37.0 */

function create_if_block(ctx) {
	let dialogportal;
	let current;

	dialogportal = new DialogPortal({
			props: {
				$$slots: { default: [create_default_slot$1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(dialogportal.$$.fragment);
		},
		m(target, anchor) {
			mount_component(dialogportal, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const dialogportal_changes = {};

			if (dirty & /*$$scope, $$restProps, onDismiss, initialFocusElement, returnFocusElement, ariaModalLegacy*/ 190) {
				dialogportal_changes.$$scope = { dirty, ctx };
			}

			dialogportal.$set(dialogportal_changes);
		},
		i(local) {
			if (current) return;
			transition_in(dialogportal.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(dialogportal.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(dialogportal, detaching);
		}
	};
}

// (13:4) <DialogOverlayInner       {...$$restProps}       {onDismiss}       {initialFocusElement}       {returnFocusElement}       {ariaModalLegacy}     >
function create_default_slot_1$1(ctx) {
	let current;
	const default_slot_template = /*#slots*/ ctx[6].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[7], null);

	return {
		c() {
			if (default_slot) default_slot.c();
		},
		m(target, anchor) {
			if (default_slot) {
				default_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && dirty & /*$$scope*/ 128) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[7], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (default_slot) default_slot.d(detaching);
		}
	};
}

// (12:2) <DialogPortal>
function create_default_slot$1(ctx) {
	let dialogoverlayinner;
	let current;

	const dialogoverlayinner_spread_levels = [
		/*$$restProps*/ ctx[5],
		{ onDismiss: /*onDismiss*/ ctx[1] },
		{
			initialFocusElement: /*initialFocusElement*/ ctx[2]
		},
		{
			returnFocusElement: /*returnFocusElement*/ ctx[3]
		},
		{
			ariaModalLegacy: /*ariaModalLegacy*/ ctx[4]
		}
	];

	let dialogoverlayinner_props = {
		$$slots: { default: [create_default_slot_1$1] },
		$$scope: { ctx }
	};

	for (let i = 0; i < dialogoverlayinner_spread_levels.length; i += 1) {
		dialogoverlayinner_props = assign(dialogoverlayinner_props, dialogoverlayinner_spread_levels[i]);
	}

	dialogoverlayinner = new DialogOverlayInner({ props: dialogoverlayinner_props });

	return {
		c() {
			create_component(dialogoverlayinner.$$.fragment);
		},
		m(target, anchor) {
			mount_component(dialogoverlayinner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const dialogoverlayinner_changes = (dirty & /*$$restProps, onDismiss, initialFocusElement, returnFocusElement, ariaModalLegacy*/ 62)
			? get_spread_update(dialogoverlayinner_spread_levels, [
					dirty & /*$$restProps*/ 32 && get_spread_object(/*$$restProps*/ ctx[5]),
					dirty & /*onDismiss*/ 2 && { onDismiss: /*onDismiss*/ ctx[1] },
					dirty & /*initialFocusElement*/ 4 && {
						initialFocusElement: /*initialFocusElement*/ ctx[2]
					},
					dirty & /*returnFocusElement*/ 8 && {
						returnFocusElement: /*returnFocusElement*/ ctx[3]
					},
					dirty & /*ariaModalLegacy*/ 16 && {
						ariaModalLegacy: /*ariaModalLegacy*/ ctx[4]
					}
				])
			: {};

			if (dirty & /*$$scope*/ 128) {
				dialogoverlayinner_changes.$$scope = { dirty, ctx };
			}

			dialogoverlayinner.$set(dialogoverlayinner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(dialogoverlayinner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(dialogoverlayinner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(dialogoverlayinner, detaching);
		}
	};
}

function create_fragment$5(ctx) {
	let if_block_anchor;
	let current;
	let if_block = /*isOpen*/ ctx[0] && create_if_block(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*isOpen*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*isOpen*/ 1) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance$5($$self, $$props, $$invalidate) {
	const omit_props_names = [
		"isOpen","onDismiss","initialFocusElement","returnFocusElement","ariaModalLegacy"
	];

	let $$restProps = compute_rest_props($$props, omit_props_names);
	let { $$slots: slots = {}, $$scope } = $$props;
	let { isOpen } = $$props;
	let { onDismiss } = $$props;
	let { initialFocusElement = null } = $$props;
	let { returnFocusElement = null } = $$props;
	let { ariaModalLegacy = false } = $$props;

	$$self.$$set = $$new_props => {
		$$props = assign(assign({}, $$props), exclude_internal_props($$new_props));
		$$invalidate(5, $$restProps = compute_rest_props($$props, omit_props_names));
		if ("isOpen" in $$new_props) $$invalidate(0, isOpen = $$new_props.isOpen);
		if ("onDismiss" in $$new_props) $$invalidate(1, onDismiss = $$new_props.onDismiss);
		if ("initialFocusElement" in $$new_props) $$invalidate(2, initialFocusElement = $$new_props.initialFocusElement);
		if ("returnFocusElement" in $$new_props) $$invalidate(3, returnFocusElement = $$new_props.returnFocusElement);
		if ("ariaModalLegacy" in $$new_props) $$invalidate(4, ariaModalLegacy = $$new_props.ariaModalLegacy);
		if ("$$scope" in $$new_props) $$invalidate(7, $$scope = $$new_props.$$scope);
	};

	return [
		isOpen,
		onDismiss,
		initialFocusElement,
		returnFocusElement,
		ariaModalLegacy,
		$$restProps,
		slots,
		$$scope
	];
}

class DialogOverlay extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance$5, create_fragment$5, safe_not_equal, {
			isOpen: 0,
			onDismiss: 1,
			initialFocusElement: 2,
			returnFocusElement: 3,
			ariaModalLegacy: 4
		});
	}
}

/* node_modules/svelte-accessible-dialog/src/components/DialogContent.svelte generated by Svelte v3.37.0 */

function add_css$1() {
	var style = element("style");
	style.id = "svelte-1nxzmey-style";
	style.textContent = "div.svelte-1nxzmey{background-color:#fff;margin:15vh auto;outline:none;padding:2rem;width:50vw}";
	append(document.head, style);
}

function create_fragment$6(ctx) {
	let div;
	let current;
	const default_slot_template = /*#slots*/ ctx[2].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[1], null);

	let div_levels = [
		/*$$restProps*/ ctx[0],
		{ "data-svelte-dialog-content": "" },
		{ "aria-modal": "true" },
		{ role: "dialog" },
		{ tabindex: "-1" }
	];

	let div_data = {};

	for (let i = 0; i < div_levels.length; i += 1) {
		div_data = assign(div_data, div_levels[i]);
	}

	return {
		c() {
			div = element("div");
			if (default_slot) default_slot.c();
			set_attributes(div, div_data);
			toggle_class(div, "svelte-1nxzmey", true);
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (default_slot) {
				default_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, [dirty]) {
			if (default_slot) {
				if (default_slot.p && dirty & /*$$scope*/ 2) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[1], dirty, null, null);
				}
			}

			set_attributes(div, div_data = get_spread_update(div_levels, [
				dirty & /*$$restProps*/ 1 && /*$$restProps*/ ctx[0],
				{ "data-svelte-dialog-content": "" },
				{ "aria-modal": "true" },
				{ role: "dialog" },
				{ tabindex: "-1" }
			]));

			toggle_class(div, "svelte-1nxzmey", true);
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (default_slot) default_slot.d(detaching);
		}
	};
}

function instance$6($$self, $$props, $$invalidate) {
	const omit_props_names = [];
	let $$restProps = compute_rest_props($$props, omit_props_names);
	let { $$slots: slots = {}, $$scope } = $$props;

	$$self.$$set = $$new_props => {
		$$props = assign(assign({}, $$props), exclude_internal_props($$new_props));
		$$invalidate(0, $$restProps = compute_rest_props($$props, omit_props_names));
		if ("$$scope" in $$new_props) $$invalidate(1, $$scope = $$new_props.$$scope);
	};

	return [$$restProps, $$scope, slots];
}

class DialogContent extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-1nxzmey-style")) add_css$1();
		init(this, options, instance$6, create_fragment$6, safe_not_equal, {});
	}
}

export { DialogContent, DialogOverlay };
